import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import { assert } from '@ember/debug';
import type { htmlSafe } from '@ember/template';
type SafeString = ReturnType<typeof htmlSafe>;

export interface AditoolsSystemDialogSignature {
  Element: HTMLDialogElement;
  Args: {
    title?: string | SafeString;
    message?: string | SafeString;
    dialogClass?: string;
    bodyClass?: string;
    dialogEnabled?: boolean;
  };
}

export default class AditoolsSystemDialog extends Component<AditoolsSystemDialogSignature> {
  @service declare intl: IntlService;

  // Parameters

  // Optional parameters with defaults applied
  get _message() {
    return this.args.message ?? this.intl.t('ember-aditools-page.dialogs.system.application-busy');
  }

  get _title() {
    return this.args.title ?? this.intl.t('ember-aditools-page.dialogs.system.title');
  }

  dontClose() {
    assert('This function must never be called - reset @dialogEnabled instead', false);
  }
}
